const scoring = {
    scoring: {
        icon: 'reconciliation',
        text: 'Penilaian',
        route: 'admin.performance.scoring',
        role: {
            performance: [ 'mentor', 'evaluator', 'advisor' ]
        }
    },
    passingGrade: {
        icon: 'ordered-list',
        text: 'Passing Grade',
        route: 'admin.performance.passing-grade',
        role: {
            performance: [ 'admin' ]
        }
    },
}

export default scoring
